<template>
  <div style="width: 100%">
    <v-data-table
        :headers="headers"
        :items="items"
        :hide-default-header="empty"
        :height="items.length > 7 ? (32 * 7 + 32 + 16) : undefined"
        disable-pagination
        item-key="none"
        hide-default-footer dense
        style="white-space: nowrap"
    >
      <template v-slot:top v-if="toolbar">
        <v-toolbar flat dense>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-divider class="mx-2" inset vertical/>
          <v-btn @click="row_create" small class="ma-2" color="primary">Add</v-btn>
          <v-spacer/>
        </v-toolbar>
      </template>
      <template v-slot:item.index ="{item}">
        <span>{{ items.indexOf(item)+1 }}</span>
      </template>
      <template v-slot:item.actions="{item}">
        <v-icon @click="row_update(item)" class="mr-2" small>mdi-pencil</v-icon>
        <v-icon @click="row_copy(item)" class="mr-2" small>mdi-content-copy</v-icon>
        <v-icon @click="row_moveup(item)" class="mr-2" small>mdi-arrow-up-thick</v-icon>
        <v-icon @click="row_movedown(item)" class="mr-2" small>mdi-arrow-down-thick</v-icon>
        <v-icon @click="row_remove(item)" class="mr-2" small>mdi-delete</v-icon>
      </template>
    </v-data-table>
    <r-level-track-level-pattern-dialog ref="dialog"/>
  </div>
</template>


<script>
import VueTypes from "vue-types";
import {ViewRules} from "@/common/ViewRules";

import { LevelTrackLevelPattern } from "@/modules/redactor/models/level-track/LevelTrackLevelPattern";

import RLevelTrackLevelPatternDialog from "@/modules/redactor/views/level-track/level/pattern/r-level-track-level-pattern-dialog.vue";

export default {
  name: "r-level-track-level-pattern-table",
  components: {RLevelTrackLevelPatternDialog},
  props: {
    title: VueTypes.string,
    items: VueTypes.arrayOf(LevelTrackLevelPattern),
    toolbar: VueTypes.bool.def(true)
  },
  data: () => ({
    headers: [
      {text: 'Artefact', value: 'artefact'},
      {text: 'Rect', value: 'rect'},
      {text: 'Rotate', value: 'rotate'},
      {text: '', value: 'actions', width: '100%', sortable: false, align: 'end'}
    ]
  }),
  computed: {
    empty() {
      return this.items.length === 0;
    }
  },
  methods: {
    row_create() {
      this.$refs['dialog'].show(ViewRules.CREATE)
          .then((data) => {
            if (this.items.find(v => v.rect[0][0] === data.rect[0][0] &&
                v.rect[1][0] === data.rect[1][0] &&
                v.rect[0][1] === data.rect[0][1] &&
                v.rect[1][1] === data.rect[1][1])) {
              this.$alert("Duplicate value!");
            } else {
              this.items.push(data);
            }
          }).catch(() => {
      });
    },
    row_remove(item) {
      this.$confirm("Are you sure you want to delete this item?").then(() => {
        const index = this.items.indexOf(item);
        this.items.splice(index, 1);
      });
    },
    row_moveup(item) {
      const index = this.items.indexOf(item);
      if (index > 0) {
        this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
      }
    },
    row_movedown(item) {
      const index = this.items.indexOf(item);
      if (index < this.items.length - 1) {
        this.items.splice(index, 2, this.items[index + 1], this.items[index]);
      }
    },
    row_copy(item) {
      this.$refs['dialog'].show(ViewRules.COPY, item.copy())
          .then((data) => {
            this.items.push(data);
          }).catch(() => {
      });
    },
    row_update(item) {
      this.$refs['dialog'].show(ViewRules.UPDATE, item.clone())
          .then((data) => {
            const index = this.items.indexOf(item);
            this.items.splice(index, 1, data);
          }).catch(() => {
      });
    }
  }
}
</script>
